var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "border-default text-blue d-flex justify-content-center cursor-pointer",
      staticStyle: { width: "50px" },
    },
    [_c("v-icon", { staticClass: "text-blue" }, [_vm._v("mdi-arrow-left ")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }